export const POSTHOG_NO_CAPTURE_CLASS = 'ph-no-capture';
